import { memo } from 'react';

import PropTypes from 'prop-types';

import Loader from '../Loader/';

const Button = memo(({ children, isSubmitting, ...rest }) => (
  <>
    <button title={typeof children === 'string' ? children : ''} {...rest}>
      {isSubmitting ? <Loader size='sm' type='text-light' /> : children}
    </button>
    <style>{`
        .disabled-light-blue {
          background-color: #aabfc3 !important;
        }
        .blue-border {
          border: 1px solid #113dbc !important;
        }
        button:focus {
          outline: none !important;
        }

        button:focus-visible {
          outline: none !important;
        }

        .font-14px {
          font-size: 14px !important;
        }

        .font-12px {
          font-size: 12px !important;
        }

        .line-height-18px {
          line-height: 18px !important;
        }

        .general-style {
          padding: 11px 1.5rem;
          font-size: 16px;
          line-height: 24px;
          font-weight: 600;
          border: none;
          border-radius: 6px;
          color: #ffffff;
          background-color: #113dbc;
        }

        .general-style:disabled {
          background-color: #aabfc3;
          border: 1px solid #aabfc3 !important;
        }

        .font-size-24px {
          font-size: 24px !important;
        }

        .pd-t-b-9 {
          padding-top: 9px !important;
          padding-bottom: 9px !important;
        }

        .wd-85 {
          width: 85% !important;
        }

        .wd-fit-content {
          width: fit-content !important;
        }

        .relative {
          position: relative;
        }
        .w-150px {
          width: 150px !important;
        }
        .h-40px {
          height: 40px !important;
        }

        .border-grey {
          border: solid 1px #d9e9ed !important;
        }

        .general-style-2 {
          padding: 1rem 0.5rem;
          font-size: 16px;
          line-height: 24px;
          font-weight: 600;
          border: none;
          border-radius: 6px;
          color: #ffffff;
          background-color: #113dbc;
          text-align: center;
          width: 160px;
        }

        .general-style-3 {
          padding: 12px 30px;
          font-size: 16px;
          line-height: 20px;
          font-weight: 600;
          border: none;
          border-radius: 6px;
          color: #ffffff;
          background-color: #113dbc;
          width: 180px;
        }

        .general-style-3:disabled {
          background-color: #aabfc3;
        }

        .general-outline-style:disabled {
          border: 1px solid #aabfc3;
          color: #aabfc3;
        }

        .general-outline-style-3:disabled {
          border: 1px solid #aabfc3;
          color: #aabfc3 !important;
        }

        .general-outline-style-min-width:disabled {
          border: 1px solid #aabfc3;
          color: #aabfc3;
        }

        .whatsapp-btn {
          background-color: #28c269;
          color: #ffffff;
          border: none;
          border-radius: 8px;
          padding: 12px;
          font-size: 14px;
          line-height: 17px;
          font-weight: 500;
          margin-top: 1.5rem;
        }

        .whatsapp-btn-2 {
          background-color: #28c269;
          color: #ffffff;
          border: none;
          border-radius: 8px;
          padding: 12px;
          font-size: 14px;
          line-height: 17px;
          font-weight: 500;
          margin-top: 1.5rem;
          position: absolute;
          bottom: -60px;
        }

        .marginAuto {
          margin: auto;
        }

        .general-style-refer {
          background-color: #ffffff;
          color: #028ef8;
          border: 1px solid #9cafb1;
          border-radius: 8px;
          font-size: 14px;
          line-height: 17px;
          font-weight: 600;
          margin-right: 16px;
          display: flex;
          padding: 9px 1.5rem;
        }

        .general-outline-style-min-width {
          padding: 8px 1.5rem;
          font-size: 16px;
          line-height: 20px;
          font-weight: 600;
          border: 1px solid #113dbc;
          border-radius: 8px;
          color: #113dbc;
          background-color: #ffffff;
          display: flex;
          justify-content: center;
          min-width: 180px;
        }

        .general-outline-style {
          padding: 8px 1.5rem;
          font-size: 16px;
          line-height: 20px;
          font-weight: 600;
          border: 1px solid #113dbc;
          border-radius: 8px;
          color: #113dbc;
          background-color: #ffffff;
          display: flex;
          justify-content: center;
        }

        .paddingTop {
          padding-top: 12px !important;
          padding-bottom: 12px !important;
        }
        .general-outline-style-2 {
          padding: 12px 20px;
          font-size: 20px;
          line-height: 24px;
          font-weight: 500;
          border: 1px solid #d9e9ed;
          border-radius: 8px;
          color: #333333;
          background-color: #d9e9ed;
          text-align: center;
        }

        .not-selected-type-2 {
          background-color: #ecf1fd !important;
        }

        .general-outline-style-2-selected {
          padding: 12px 20px;
          font-size: 20px;
          line-height: 24px;
          font-weight: 600;
          border: 1px solid #113dbc;
          border-radius: 8px;
          color: #113dbc;
          background-color: #d9e9ed;
          text-align: center;
        }

        .general-grey-selected {
          padding: 12px 20px;
          font-size: 18px;
          line-height: 24px;
          font-weight: 700;
          border: none;
          border-radius: 8px 8px 0 0;
          color: #ffffff;
          background-color: #3c4858;
          text-align: center;
        }

        .general-grey-not-selected {
          padding: 12px 20px;
          font-size: 16px;
          line-height: 20px;
          font-weight: 500;
          border: none;
          color: #1f2d3d;
          background-color: transparent;
          text-align: center;
        }

        .selected-type-2 {
          background-color: #ffffff !important;
        }

        .general-outline-style-3 {
          padding: 8px 20px;
          font-size: 16px;
          line-height: 20px;
          font-weight: 600;
          border: 1px solid #113dbc;
          border-radius: 8px;
          color: #1f2d3d;
          background-color: #ffffff;
          text-align: center;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          min-width: 180px;
        }

        .general-outline-style-disabled {
          padding: 8px 20px;
          font-size: 16px;
          line-height: 20px;
          font-weight: 600;
          border: 1px solid #b7c3f4;
          border-radius: 8px;
          color: #b7c3f4;
          background-color: #ffffff;
          text-align: center;
        }

        .padding32L {
          padding-left: 32px !important;
        }

        .padding32R {
          padding-right: 32px !important;
        }

        .full-width-imp {
          width: 100% !important;
        }

        @media screen and (max-width: 768px) {
          .general-grey-selected {
            padding: 8px 12px;
            font-size: 12px;
            line-height: 16px;
            border-radius: 12px;
            height: 34px;
            border: 1px solid #3c4858;
          }

          .general-grey-not-selected {
            padding: 8px 12px;
            font-size: 12px;
            border-radius: 12px;
            line-height: 16px;
            height: 34px;
            border: 1px solid #d9e9ed;
            background: #ffffff;
          }

          .general-style-refer {
            padding: 9px 0;
          }

          .general-style-3 {
            width: 100%;
            margin-top: 30px;
          }

          .margin-top-15 {
            margin-top: 15px !important;
          }

          .general-outline-style-3 {
            width: 70%;
          }

          .general-style {
            padding: 12px 20px;
            font-size: 10px;
            line-height: 12px;
            font-weight: 600;
            border: none;
            border-radius: 6px;
            color: #ffffff;
            background-color: #113dbc;
          }

          .save-and-exit-button {
            width: 100%;
          }

          .save-and-continue-button {
            width: 100%;
          }

          .save-and-continue-button:disabled {
            height: 40px;
            border: 1px solid #9cafb1;
            width: 100%;
          }

          .no-border-btn {
            background-color: #ffffff;
            color: #1f2d3d;
            border: none;
            padding: 12px 0 0 16px;
            font-size: 14px;
            line-height: 18px;
            font-weight: 600;
            display: flex;
          }

          .general-outline-style-2 {
            padding: 10px 16px;
            font-size: 16px;
            line-height: 19.36px;
          }

          .general-outline-style-2-selected {
            padding: 10px 16px;
            font-size: 16px;
            line-height: 19.36px;
          }

          .general-style-4 {
            padding: 8px 20px;
            font-size: 16px;
            line-height: 20px;
            font-weight: 600;
            border: none;
            border-radius: 6px;
            color: #ffffff;
            background-color: #113dbc;
            text-align: center;
            width: 156px;
          }
        }
      `}</style>
  </>
));

Button.displayName = 'Button';

Button.proTypes = {
  children: PropTypes.element
};

export default Button;
